<template>
  <tr>
    <td>{{lead.id}}</td>
    <td>{{lead.user.user.username}}</td>
    <td>{{lead.user.profile.fullname}}</td>
    <td>{{formatDate(lead.user.user.createdon)}}</td>
    <td>{{subType}}</td>
    <td>{{status}}</td>
  </tr>
</template>

<script>
export default {
  props: {
    lead: Object
  },

  computed: {
    subType() {
      let subtype = "";
      if (this.lead.user.data.sub_type === "1") {
        subtype = "מנוי חודשי";
      }

      if (this.lead.user.data.sub_type === "2") {
        subtype = "מנוי שנתי";
      }

      if (this.lead.user.data.sub_type === "3") {
        subtype = "מורה";
      }

      if (this.lead.user.data.sub_type === "4") {
        subtype = "מנוי מתנה";
      }
      return subtype;
    },
    status() {
      if (this.lead.status === 1) {
        return "כן";
      }
      return "לא ";
    }
  },

  methods: {
    formatDate(d) {
      const date = new Date(d);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }
  }
};
</script>

<style>
</style>
